export var getLang = function (_a) {
    var settings = _a.reactPage.settings;
    return settings.lang;
};
//# sourceMappingURL=setting.js.map